import { Link } from 'react-router-dom';
import Logo from './Logo.png';
import React, { useState } from 'react';

function Navbar()
{
    const [showPopup, setShowPopup] = useState(false);
    
    const handleDevClick = () => {
        setShowPopup(true);
        setTimeout(() => setShowPopup(false), 2000); // Hide after 2 seconds
    };
    return(
        <div className='top-part-of-landing-page'>
            {showPopup && (
                <div style={{
                position: 'fixed',
                top: '20px',
                right: '20px',
                backgroundColor: '#333',
                color: 'white',
                padding: '15px 25px',
                borderRadius: '8px',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                zIndex: 1000,
                animation: 'fadeIn 0.3s'
                }}>
                In Development
                </div>
            )}

            <Link to='/' style={{ 
                display: 'flex', 
                alignItems: 'center', 
                textDecoration: 'none', 
                color: 'inherit',
                pointerEvents: 'auto',
                zIndex: 10
            }}>
                <img 
                    src={Logo} 
                    alt="EngineeringCubes Logo" 
                    className="company-logo" 
                    style={{ cursor: 'pointer', pointerEvents: 'auto' }} 
                  />
                  <div className='Company-name' style={{ cursor: 'pointer', pointerEvents: 'auto' }}>
                    Engineering Cubes
                  </div>
                </Link>
                
                <div className='Quick-Links'>
                  
                  <Link to='/about' style={{ textDecoration: 'none', color: 'inherit' }}>
                    <div  style={{ cursor: 'pointer' }}>About</div>
                  </Link>
                  
                  
                  <Link to='/contact' style={{ textDecoration: 'none', color: 'inherit' }}>
                    <div style={{ cursor: 'pointer' }}>Contact</div>
                  </Link>
                  
                  
                  <Link to='/showroom' style={{ textDecoration: 'none', color: 'inherit' }}>
                    <div style={{ cursor: 'pointer' }}>Showroom</div>
                  </Link>
                  
                  <Link to="/login" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <div>Portal</div>
                  </Link>
                  <div onClick={handleDevClick} style={{ cursor: 'pointer' }}>AR/EN</div>
                </div>
              </div>
    )
}

export default Navbar